export default __webpack_public_path__ + "static/media/fridge1-before1-480w.2eb89a42.avif";